import { IDynamicSearchListController1Return } from "./DynamicSearchListController1";
import CSSClassSerivce from "../../../../services/CommonCSSSerivce";
import TextInputType1 from "../text/TextInputType1";
import InputValidationFactory from "../../../../factorys/inputvalidation/InputValidationFactory";
import { IInputValidationItemProps, IInputValidatorItem } from "../../../../factorys/inputvalidation/interfaces/InputValidationInterfaces";
import { EInputValidationResultType } from "../../../../factorys/inputvalidation/enums/InputValidationEnums";
import { InputValidation } from "../../../../factorys/inputvalidation/InputValidation";

interface IDynamicSearchListProps<T> extends IInputValidationItemProps {
  label?: string;
  placeholder?: string;
  name?: string;
  required?: boolean;
  isDisabled?: boolean;
  dlsc: IDynamicSearchListController1Return<T>;
  classNameAdd?: string;
  onInputValidation?: ((it: EInputValidationResultType) => void) | null;
  fOnInputChange?: ((it: string | null) => void) | null;
  validationItems?: IInputValidatorItem[] | null;
  fAddGlobal?:() => void;
}

export const DynamicSearchList1: React.FC<IDynamicSearchListProps<any>> = (props: IDynamicSearchListProps<any>): JSX.Element => {

  //const defaultValue = props.dlsc.getItemAsString()

  const ivc = InputValidationFactory.getInputValidationController({
    validationItems: props.validationItems, 
    itemProps: props,
    itemController: props.dlsc,
      onMount:()=>{
        //console.log("props.defaultValue: "+ props.defaultValue)
        ivc?.validate({value: props.dlsc.getItemAsString(), ignoreBlur: false })
        //setTimeout(()=>ivc?.validate({value: "", ignoreBlur: false }),2000 )
    }
  });

  const classAdd = props.classNameAdd?props.classNameAdd:"p-2";


  return (
    <div 
      className={"w-full flex flex-col relative " +classAdd}
      onMouseLeave={(e) => { props.dlsc.setFocused(false) }}
    >
 
      <TextInputType1
        keyStart={props.dlsc.getItemAsString()}
        type={"text"}
        label={props.label}
        placeholder={props.placeholder}
        name={props.name}
        defaultValue={props.dlsc.getItemAsString()}
        required={props.required}
        disabled={props.isDisabled?props.isDisabled:false}
        classNameInput={CSSClassSerivce.textInputClass}
        disabledAddClass={CSSClassSerivce.disabledAddClass}
        //validationItems = {props.validationItems}
        //onInputIsValid={(it) => props.onInputIsValid?props.onInputIsValid(it):{} }
        fOnFocus={() => { props.dlsc.setFocused(true) }}
        fOnClick={() => { props.dlsc.setFocused(true) }}
        onInputChange={(it) => {
          try {
            props.dlsc.setItemsByString(it);
            ivc?.validate({ value: it });
            //function added to the GUIElementsfactory. Is called  by every elemete build wiht this factory settings
            props.fAddGlobal ? props.fAddGlobal() : null;
          } catch (e) {
            console.log(e);
          }
        }}
      />
      <div className={`${!props.dlsc.focused?"collapse":"z-20"} `}>
      {/* <div className={"z-20"}> */}
        <ul 
          className={"absolute max-h-[12rem] w-[calc(100%-1rem)] overflow-y-scroll border-1 border-gray-500 border-rounded-lg border-2 cursor-pointer bg-white"}
          key={props.dlsc.getItemAsString()}
          >
          { props.dlsc.itemsAsStrings.map((option,idx) =>
          <li 
            className={"hover:bg-gray-300 rounded-lg p-1"}
            //key={props.dlsc.getItemAsString()} //???
            key={props.dlsc.getItemAsString()+idx.toString()} //???
            //key={option.toString()+idx.toString} //???
            onClick={(it) => {
            try {
              props.dlsc.setItemByString(option);
              ivc?.validate({value: option});
              props.fAddGlobal ? props.fAddGlobal() : null;
              props.dlsc.setFocused(false);
            } catch (e) {
            }
          }}
          >{option.valueOf()}</li>)}
        </ul>
      </div>

      {(ivc != null) ? <InputValidation
        //key={key} //hint: keychange triggers input to reRender
        ivc={ivc} /> : <></>}  
    </div>

  );
};

export default DynamicSearchList1;